export default {
	projectTitle: "速普数字技术三维可视化平台"
};



// WEBPACK FOOTER //
// ./src/constant/common.js